function initCursor() {
  const dot  = document.getElementById('cursor-dot');
  const ring = document.getElementById('cursor-ring');

  if (!dot || !ring) return;

  let mouseX = 0, mouseY = 0;
  let ringX  = 0, ringY  = 0;

  // Mueve el punto exactamente con el puntero
  document.addEventListener('mousemove', (event) => {
    mouseX = event.clientX;
    mouseY = event.clientY;
    dot.style.left = mouseX - 4 + 'px';
    dot.style.top  = mouseY - 4 + 'px';
  });

  // El anillo sigue con inercia suave (lerp)
  function animateRing() {
    ringX += (mouseX - ringX - 16) * 0.15;
    ringY += (mouseY - ringY - 16) * 0.15;
    ring.style.left = ringX + 'px';
    ring.style.top  = ringY + 'px';
    requestAnimationFrame(animateRing);
  }
  animateRing();
}
